import { useEffect } from "react";
import { Alert, Card, Spin, Typography } from "antd";
import { useAuth } from "../contexts/AuthContext";

const { Paragraph, Title } = Typography;
const SESSION_KEYS = [
  "authToken",
  "refreshToken",
  "accessTokenExpiresAt",
  "refreshTokenExpiresAt",
  "userPrivileges",
];

const safeTargetPath = (value) => {
  if (!value?.startsWith("/") || value.startsWith("//")) return "/home";
  return value;
};

const ingestHandoffSession = () => {
  if (typeof window === "undefined" || window.location.pathname !== "/auth/handoff") {
    return { hasToken: false, targetPath: "/home" };
  }

  const fragment = new URLSearchParams(window.location.hash.replace(/^#/, ""));
  const query = new URLSearchParams(window.location.search);
  SESSION_KEYS.forEach((key) => {
    const value = fragment.get(key);
    if (value) {
      window.sessionStorage.setItem(key, value);
    } else {
      window.sessionStorage.removeItem(key);
    }
  });

  const clientId = fragment.get("clientId");
  if (clientId) window.localStorage.setItem("clientId", clientId);

  const workspaceId = query.get("workspaceId");
  if (workspaceId) {
    window.localStorage.setItem("selectedWorkspaceId", workspaceId);
    window.localStorage.setItem("selectedWorkspaceReady", "1");
  }

  return {
    hasToken: Boolean(fragment.get("authToken")),
    targetPath: safeTargetPath(query.get("targetPath")),
  };
};

const handoff = ingestHandoffSession();

export default function AuthHandoff() {
  const { isAuthenticated, loading } = useAuth();

  useEffect(() => {
    if (handoff.hasToken && !loading && isAuthenticated) {
      window.location.replace(handoff.targetPath);
    }
  }, [isAuthenticated, loading]);

  const failed = !handoff.hasToken || (!loading && !isAuthenticated);
  return (
    <div style={{ minHeight: "100vh", display: "grid", placeItems: "center" }}>
      <Card style={{ width: "min(420px, calc(100vw - 32px))" }}>
        {failed ? (
          <Alert
            type="error"
            showIcon
            title="Could not open the mobile session"
            description={handoff.hasToken
              ? "Olitask received the mobile session, but the identity service could not verify it. Please return to the app and try again."
              : "The browser did not receive the mobile session. Please return to the app and try again."}
          />
        ) : (
          <>
            <Spin />
            <Title level={4} style={{ marginTop: 16 }}>Opening subscriptions</Title>
            <Paragraph style={{ marginBottom: 0 }}>Preparing your Olitask session.</Paragraph>
          </>
        )}
      </Card>
    </div>
  );
}
